import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BookingPage from "../pages/booking/page";
import PhilosophyPage from "../pages/philosophy/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminGate from "../pages/admin/components/AdminGate";
import AdminDashboard from "../pages/admin/page";
import AdminServicesPage from "../pages/admin/services/page";
import AdminPortfolioPage from "../pages/admin/portfolio/page";
import AdminHomepagePage from "../pages/admin/homepage/page";
import AdminContentPage from "../pages/admin/content/page";
import AdminOrdersPage from "../pages/admin/orders/page";
import AdminPhotographersPage from "../pages/admin/photographers/page";
import AdminPhotographerAvailabilityPage from "../pages/admin/photographer-availability/page";
import AdminBookingConfirmationsPage from "../pages/admin/booking-confirmations/page";
import AdminLegalDocumentsPage from "../pages/admin/legal-documents/page";
import AdminAssignmentsPage from "../pages/admin/assignments/page";
import AdminItinerariesPage from "../pages/admin/itineraries/page";
import AdminBookingCostItemsPage from "../pages/admin/booking-cost-items/page";
import AdminBookingNotesPage from "../pages/admin/booking-notes/page";
import AdminCancellationLogsPage from "../pages/admin/order-cancellation-logs/page";
import AdminRescheduleLogsPage from "../pages/admin/order-reschedule-logs/page";
import AdminDispatchPage from "../pages/admin/dispatch/page";
import AdminRelayPage from "../pages/admin/relay/page";
import AdminPhotographerApplicationsPage from "../pages/admin/photographer-applications/page";
import PhotographerLoginPage from "../pages/photographer/login/page";
import PhotographerApplyPage from "../pages/photographer/apply/page";
import PhotographerDashboardPage from "../pages/photographer/dashboard/page";
import PhotographerMessagesPage from "../pages/photographer/messages/page";
import CustomerLoginPage from "../pages/customer/login/page";
import CustomerDashboardPage from "../pages/customer/dashboard/page";
import CustomerMessagesPage from "../pages/customer/messages/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/booking", element: <BookingPage /> },
  { path: "/philosophy", element: <PhilosophyPage /> },

  { path: "/photographer/login", element: <PhotographerLoginPage /> },
  { path: "/photographer/apply", element: <PhotographerApplyPage /> },
  { path: "/photographer/dashboard", element: <PhotographerDashboardPage /> },
  { path: "/photographer/messages", element: <PhotographerMessagesPage /> },

  { path: "/customer/login", element: <CustomerLoginPage /> },
  { path: "/customer/dashboard", element: <CustomerDashboardPage /> },
  { path: "/customer/messages", element: <CustomerMessagesPage /> },

  { path: "/admin/login", element: <AdminLoginPage /> },

  {
    path: "/admin",
    element: <AdminGate />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "services", element: <AdminServicesPage /> },
      { path: "portfolio", element: <AdminPortfolioPage /> },
      { path: "homepage", element: <AdminHomepagePage /> },
      { path: "content", element: <AdminContentPage /> },
      { path: "orders", element: <AdminOrdersPage /> },
      { path: "photographers", element: <AdminPhotographersPage /> },
      { path: "photographer-availability", element: <AdminPhotographerAvailabilityPage /> },
      { path: "booking-confirmations", element: <AdminBookingConfirmationsPage /> },
      { path: "legal-documents", element: <AdminLegalDocumentsPage /> },
      { path: "booking-cost-items", element: <AdminBookingCostItemsPage /> },
      { path: "booking-notes", element: <AdminBookingNotesPage /> },
      { path: "order-cancellation-logs", element: <AdminCancellationLogsPage /> },
      { path: "order-reschedule-logs", element: <AdminRescheduleLogsPage /> },
      { path: "assignments", element: <AdminAssignmentsPage /> },
      { path: "itineraries", element: <AdminItinerariesPage /> },
      { path: "dispatch", element: <AdminDispatchPage /> },
      { path: "relay", element: <AdminRelayPage /> },
      { path: "photographer-applications", element: <AdminPhotographerApplicationsPage /> },
    ],
  },

  { path: "*", element: <NotFound /> },
];

export default routes;
